export default "__VITE_ASSET__DlzIga8K__"